export type ExternalScreenProps = {
  className?: string
  children?: JSX.Element
}

export const ExternalScreen = ({ className = 'bg-white shadow-lg', children }: ExternalScreenProps) => {
  return (
    <div className="flex w-screen h-screen justify-center items-start sm:items-start bg-white overflow-auto dupr-background">
      <div className={`w-full sm:w-[384px] max-h-full sm:max-h-[743px] h-fit ${className ? className : ''}`}>
        {children}
      </div>
    </div>
  )
}

export default ExternalScreen
